"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EAllowedKeys = exports.EDeviceType = void 0;
var EDeviceType;
(function (EDeviceType) {
    EDeviceType["Mobile"] = "MOBILE";
    EDeviceType["Desktop"] = "DESKTOP";
})(EDeviceType || (exports.EDeviceType = EDeviceType = {}));
var EAllowedKeys;
(function (EAllowedKeys) {
    EAllowedKeys["AGENCY"] = "agency";
    EAllowedKeys["B2B_MARKUP"] = "b2bMarkup";
    EAllowedKeys["BD4_TRAVEL_USER_ID"] = "bd4TravelUserId";
    EAllowedKeys["DEVICE"] = "device";
    EAllowedKeys["LANGUAGE"] = "language";
    EAllowedKeys["PARTNER"] = "partner";
})(EAllowedKeys || (exports.EAllowedKeys = EAllowedKeys = {}));
//# sourceMappingURL=request-util.types.js.map